(function ($, Drupal, window, document) {

  'use strict';

  Drupal.behaviors.product_overview_page_overview = {
    attach: function (context, settings) {

      $(document).ready(function() {

        // Move the bg's to the wrapper
        $(once('appendto', '.product-overview__bg_wrapper')).each(function() {
          $(this).appendTo('.bg-wrapper');
        });

        // Make the first one active
        $('.bg-wrapper .product-overview__bg_wrapper:first').addClass('active');

        // Hover index logic (eq = index - 1)
        $('.node--type-product-overview-page.node--view-mode-teaser').hover(function() {
          $('.product-overview__bg_wrapper').removeClass('active');
          $('.bg-wrapper .product-overview__bg_wrapper').eq($(this).index() - 1).addClass('active');
        });

      });

    }
  };

})(jQuery, Drupal, this, this.document);
